export default {
 template: require('./wtg-ticket-list.html'),
 bindings: {
  group: "@",           // the group of ticket lists, sharing
                        // collapsibility
  instance: "@",        // the unique instance of the list
  tickets: "<",         // list of tickets, which is in fact,
                        // a hierarchy having person at the first
                        // level: [
                        //  {acid:,display_name:,c:[
                        //   {id:,ts:},…
                        //  ]},…
                        // ]
  selectedAccount: "<",         // currently selected account
  selectedConversation: "<"     // currently selected conversation
 },
 controller: function($scope,$rootScope,INTERACT) {
  $scope.strings = $rootScope.strings;
  // TODO: it should not operate on ids ultimately
  $scope.has_unread_tickets = function(acid) {
   return INTERACT.get_account(acid).has_unreads();
  };
  $scope.has_unread_messages = function(cid) {
   return INTERACT.get_conversation(+cid).has_unreads();
  };
 }
};
/* vim:set ts=8 sw=1 expandtab: */
